import { useEffect, useState } from 'react';
import { AutoExchange } from 'src/redux/modules/autoExchange/actionTypes';
import {
  APP_FAILURE,
  DOB_FAILURE,
  EXCHANGE_TO_EXISTING_LOAD_FAILED,
  FOREIGN_ADDRESS,
} from 'src/settings/settings';

export function useErrorCheck({
  hasAppFailed,
  hasExchangeToExistingLoadFailed,
  hasTransactionFailed,
  hasValidationFailed,
  isCorporateAccountType,
  dateOfBirth,
  personalInfoFailed,
  isNotForeignAddress,
}) {
  const [hasError, setError] = useState(false);
  const [errorType, setErrorType] = useState('');
  useEffect(() => {
    setError(true);
    setErrorType('');

    // assumption: getError checks for failures in order,
    // otherwise this can bre refactored to a redux state
    if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
      setErrorType(DOB_FAILURE);
      return;
    }
    if (!personalInfoFailed && !isNotForeignAddress) {
      setErrorType(FOREIGN_ADDRESS);
      return;
    }
    if (hasAppFailed) {
      setErrorType(APP_FAILURE);
      return;
    }

    if (hasExchangeToExistingLoadFailed) {
      setErrorType(EXCHANGE_TO_EXISTING_LOAD_FAILED);
      return;
    }

    if (hasTransactionFailed) {
      setErrorType(AutoExchange.FAILURE);
      return;
    }

    if (hasValidationFailed) {
      setErrorType(AutoExchange.VALIDATION_FAILURE);
      return;
    }

    // default case
    setError(false);
  }, [
    hasAppFailed,
    hasExchangeToExistingLoadFailed,
    hasTransactionFailed,
    hasValidationFailed,
    dateOfBirth,
    isCorporateAccountType,
    isNotForeignAddress,
    personalInfoFailed,
  ]);

  return { hasError, errorType };
}
